import { MemoryFieldDto } from '../services/MendsVisionService';

function basisLabel(basis: string) {
  if (basis === 'explicit') return 'explícito';
  if (basis === 'inferred') return 'inferência';
  return basis;
}

function formatWhen(value?: string) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('pt-BR');
}

function FieldRow({ field, past }: { field: MemoryFieldDto; past?: boolean }) {
  return (
    <li className={past ? 'mai-field is-past' : 'mai-field'}>
      <span className="mai-field-label">{field.label}</span>
      <span className="mai-field-value">{field.value}</span>
      <span className={`mai-field-basis is-${field.basis}`}>{basisLabel(field.basis)}</span>
      {formatWhen(field.updatedAt) && (
        <span className="mai-field-when">{formatWhen(field.updatedAt)}</span>
      )}
    </li>
  );
}

export function CommercialFieldList({
  properties,
  history,
}: {
  properties?: MemoryFieldDto[];
  history?: MemoryFieldDto[];
}) {
  const current = properties ?? [];
  const past = history ?? [];
  if (current.length === 0 && past.length === 0) return null;

  return (
    <div className="mai-fields">
      {current.length > 0 && (
        <ul className="mai-field-list">
          {current.map((field) => (
            <FieldRow key={`${field.slot}-${field.value}`} field={field} />
          ))}
        </ul>
      )}
      {past.length > 0 && (
        <details className="mai-field-history">
          <summary>Correções anteriores</summary>
          <ul className="mai-field-list">
            {past.map((field, index) => (
              <FieldRow key={`${field.slot}-${index}`} field={field} past />
            ))}
          </ul>
        </details>
      )}
    </div>
  );
}
